import { useState, useEffect, useRef, useContext } from "react";
import { WellContext } from "../context/WellContext";

import React from "react";

function Transmitter4({
  tag,
  value,
  x,
  y,
  unit = "",
  scale = 1,
  MinValue = 0,
  c,
}) {

  // ✅ SIMPLE SAFE VALUE
  const safeValue = Number(value);
  const displayValue =
    !isNaN(safeValue) && safeValue !== null
      ? safeValue * scale
      : MinValue;

  return (
    <div
      style={{
        position: "absolute",
        left: x,
        top: y,
        padding: "4px 6px",
        borderRadius: "4px",
        fontSize: "10px",
        fontWeight: "bold",
        backgroundColor: "transparent",
        color: c,
      }}
    >
      {displayValue.toFixed(2)} {unit}
    </div>
  );
}

export default Transmitter4;